import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-accordionheader',
  toggleicon: 'p-accordionheader-toggle-icon'
};
var AccordionHeaderStyle = BaseStyle.extend({
  name: 'accordionheader',
  classes: classes
});

export { AccordionHeaderStyle as default };
//# sourceMappingURL=index.mjs.map
